import { useSelector } from "react-redux";
import { selectCompany } from "../store/slices/authSlice";
import { COMPANY_MARKINGS_GROUP } from "../types/const";

const useGetCompanyMarkingNr = () => {
  const company = useSelector(selectCompany);
  if (!company || !COMPANY_MARKINGS_GROUP[company]) {
    throw new Error(`Company ${company} is not supported or not defined.`);
  }
  return COMPANY_MARKINGS_GROUP[company];
};
export default useGetCompanyMarkingNr;
